import React, { useMemo } from 'react';
import { USER_ROLES } from 'utils/Constants';

import Show from 'components/Show';
import Avatar from 'components/Misc/Avatar';
import { Title } from 'components/Misc/Typography';

import { useAppStore } from 'store/useAppStore';
import { useMessengerStore } from 'store/useMessengerStore';
import Button from 'components/Ui/Button';

const Recipient = () => {
	// Use app's store
	const user = useAppStore(state => state.user);

	// Use messenger's store
	const [pending, updateView] = useMessengerStore(state => [state.pending, state.updateView]);
	const conversation = useMessengerStore(state => state.conversations.find(c => c.id === state.active));

	// Store conversation's recipient
	const recipient = useMemo(() => conversation?.participants?.find(p => p.id !== user.id), [user, conversation]);

	// Store recipients's role
	const role = useMemo(() => USER_ROLES.find(r => r.value === recipient?.role) ?? USER_ROLES.find(r => r.value === pending.role), [recipient, pending]);

	// Handle view change to conversations
	const onBack = () => updateView('conversations');

	return (
		<div className="px-3 h-12 flex items-center space-x-3 bg-neutral-100 dark:bg-neutral-700 transition-colors">
			<Button
				small
				square
				icon="arrow_back"
				onClick={onBack}
			/>

			<div className="flex items-center space-x-2">
				{/* Pedning conversation's recipient */}
				<Show if={pending?.id}>
					<Avatar
						small
						alt={pending?.fullName}
						src={pending?.avatar}
						online={pending?.online}
					/>

					<Title
						title={pending?.fullName}
						subtitle={role?.name}
						className="flex-1 leading-tight"
					/>
				</Show>

				{/* Existing conversation's recipient */}
				<Show if={recipient?.id}>
					<Avatar
						small
						alt={recipient?.fullName}
						src={recipient?.avatar}
						online={recipient?.online}
					/>

					<Title
						title={recipient?.fullName}
						subtitle={role?.name}
						className="flex-1 leading-tight"
					/>
				</Show>
			</div>
		</div>
	);
};

export default Recipient;